const AUTH_INTENT_KEY = "edify_auth_intent_v1";
const AUTH_INTENT_TTL_MS = 15 * 60 * 1000;

export type AuthIntent = {
  action: "start_kyc";
  source: "profile" | "workbag";
  returnTo: string;
  email?: string;
  createdAt: number;
};

export function setStartKycAuthIntent(payload: Omit<AuthIntent, "action" | "createdAt">): void {
  const intent: AuthIntent = {
    action: "start_kyc",
    source: payload.source,
    returnTo: payload.returnTo,
    email: payload.email,
    createdAt: Date.now(),
  };
  localStorage.setItem(AUTH_INTENT_KEY, JSON.stringify(intent));
}

export function consumeAuthIntent(): AuthIntent | null {
  const raw = localStorage.getItem(AUTH_INTENT_KEY);
  localStorage.removeItem(AUTH_INTENT_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as AuthIntent;
    if (!parsed?.action || !parsed?.createdAt) return null;
    if (Date.now() - parsed.createdAt > AUTH_INTENT_TTL_MS) return null;
    return parsed;
  } catch {
    return null;
  }
}
